const DAY = 1000 * 60 * 60 * 24;

export const isOlderThan24Hours = (date: Date): boolean => {
  const comparedDate = date.getTime();
  const now = new Date().getTime();
  return now - comparedDate > DAY;
};
